import {DomainEvent} from './DomainEvent';
import {CompetitionSeasonTopScorers} from '../resources/CompetitionSeasonTopScorers';

export class CompetitionSeasonTopScorersCreated extends DomainEvent<CompetitionSeasonTopScorers> {}
